import React from "react";
import { Anchor, Phone, Users } from "lucide-react";
import { CONTACT } from "../data/cruiseData";

/* ─────────────────────────────────────────────────────────────
 * TrustBar, slim top-of-page strip persistent across the site
 * Reinforces: "All cruises are private full-boat charters."
 * Sits above the navbar in App layout.
 * ───────────────────────────────────────────────────────────── */
export default function TrustBar() {
 return (
  <div className="relative w-full bg-[#0A1428] border-b border-amber-300/15 text-white" data-testid="trust-bar">
   <div className="mx-auto max-w-7xl px-5 lg:px-10 py-2 flex items-center justify-between gap-3 text-[10px] sm:text-[11px] uppercase tracking-[0.22em] font-bold">
    <div className="flex items-center gap-2 sm:gap-3 min-w-0">
     <Anchor className="w-3.5 h-3.5 text-amber-300 shrink-0" strokeWidth={2} />
     <span className="text-white/85 truncate">
      <span className="hidden md:inline">All cruises are </span>
      <span className="text-amber-300">private full-boat charters</span>
      <span className="hidden sm:inline"> · <Users className="inline w-3 h-3 mb-0.5" /> capacity up to 120</span>
     </span>
    </div>
    <a href={`tel:${CONTACT.phone1}`} className="hidden sm:inline-flex items-center gap-1.5 text-amber-300 hover:text-amber-200 transition-colors shrink-0" data-testid="trust-bar-phone">
     <Phone className="w-3 h-3" /> {CONTACT.phone1}
    </a>
   </div>
  </div>
 );
}
